/**
 * The single place a session is written to localStorage.
 *
 * Two paths establish a session: the password login (useAuth.login) and the
 * MS-490 resume-token exchange. They must write an identical key set — a
 * half-hydrated session fails later in ways that are hard to trace back here.
 */
import { jwtDecode } from "jwt-decode";

export interface SessionUser {
  id?: number;
  fullName?: string;
  email?: string;
  ownerId?: number;
  gathernToken?: string;
  gathernTokenExpired?: string;
  channexChannelId?: string;
  role?: { rolePermissions?: unknown };
}

export interface SessionResult {
  token: string;
  user?: SessionUser;
  showWebsiteBuikder?: boolean;
}

export const persistSession = (result: SessionResult): void => {
  const { exp } = jwtDecode(result.token);

  window.localStorage["userName"] = result?.user?.fullName;
  window.localStorage["userId"] = result?.user?.id;
  window.localStorage["ownerId"] = result?.user?.ownerId;
  window.localStorage["email"] = result?.user?.email;
  window.localStorage["gathernToken"] = result?.user?.gathernToken;
  window.localStorage["gathernTokenExpired"] = result?.user?.gathernTokenExpired;
  window.localStorage["channexChannelId"] = result?.user?.channexChannelId;

  // Store rolePermissions for immediate navigation
  if (result?.user?.role?.rolePermissions) {
    window.localStorage["rolePermissions"] = JSON.stringify(
      result.user.role.rolePermissions
    );
  }

  // TODO, get rid of all above info and keep below
  window.localStorage["user"] = JSON.stringify(result?.user);
  window.localStorage["token"] = result?.token;
  window.localStorage["exp"] = `${exp! * 1000}`;
  window.localStorage["showWebsiteBuikder"] = result?.showWebsiteBuikder
    ? "true"
    : "false";
};
